import React from 'react';
import { HPWrapper } from './style';
import { useSelector } from 'react-redux';

// Component
import Text from 'components/common/Text';

const HPItem = ({ 
  item: {HealthProvider, Name, cityDetails}, 
  onClick,
  selected,
  id,
  borderColor
}) => {
const {webConfig} = useSelector(state => state.core);

return (
    <HPWrapper 
        key={HealthProvider}
        onClick={() => onClick(HealthProvider)}
        selected={HealthProvider === selected}
        id={id}
        borderColor={borderColor}
    >
        {webConfig.lang !== 'fa'
        ?
        <Text
            tag="h2"
            className="text"
        >
        {Name} ({cityDetails?.Slug})
        </Text>
        :
        <Text
            tag="h2"
            className="text"
        >
        {Name} ({cityDetails?.Title})
        </Text>
        }
    </HPWrapper>
)
};

export default HPItem;